import { Form, Button, Table, Modal, Dropdown } from "react-bootstrap";
import { useEffect, useState, useMemo } from "react";
// import MagnifyIcon from "mdi-react/MagnifyIcon";
import { useQuery, useMutation } from "react-query";
import queryString from "query-string";
import { toast } from "react-toastify";
import { cloneDeep, truncate, uniqBy } from "lodash";
import Select from "react-select";

import "../assets/scss/reports/cashbook.scss";
import { paginationOptions, defaultSelectValue, Units } from "../utils/helpers";
import { useAuth } from "../hooks/useAuth";
import ReactPaginate from "react-paginate";
import { fetchActionsUtil } from "../utils/helpers";
import NoTableItem from "./utils/NoTableItem";
import useDebounce from "../utils/hooks";
import ConvertQuantity from "./utils/ConvertQuantity";
import { scrollToTop } from "../utils/helpers";
import ConfirmDialog from "./ConfirmDialogue";
import ModalLoader from "./utils/ModalLoader";
import CurrencyCustomInput from "./utils/CurrencyCustomInput";
import currency from "currency.js";
import NumberCustomInput from "./utils/NumberCustomInput";
import MagnifyIcon from "mdi-react/MagnifyIcon";
import { isEmpty } from "lodash";
import { read, utils } from "xlsx";
import * as yup from "yup";
import { DownloadMobileIcon, ExcelIcon } from "./Icons";
import Datetime from "react-datetime";
import { format } from "date-fns";
import SelectBatchDialog, {
  SelectBatchDialogV2,
} from "./SalesAndInvoicing/SelectBatchDialog";
import BatchSelectorModal from "./Inventory/BatchSelectorModal";
import { useStoreState } from "easy-peasy";

const initialFilterParams = {
  page: 1,
  limit: 100,
  itemId: "",
};

export default function AddStockCountAtDate({
  showAddStockCountAtDate,
  setShowAddStockCountAtDate,
  refetch,
}) {
  const itemMeasurements = useStoreState(state => state.itemMeasurements);
  const { backendUrl, token } = useAuth();

  const [selectedData, setSelectedData] = useState([]);
  const [selectedAllData, setSelectedAllData] = useState([]);
  const [showSelected, setShowSeleted] = useState(false);
  const [showBatchSelectorModal, setShowBatchSelectorModal] = useState(false);
  const [activeBatchItem, setActiveBatchItem] = useState(null);

  const [queryParams, setQueryParams] = useState({
    ...initialFilterParams,
  });

  const [filterParams, setFilterParams] = useState({
    ...queryParams,
    ...initialFilterParams,
  });

  const debouncedFilterParams = useDebounce(filterParams, 500);

  useEffect(() => {
    setQueryParams(q => ({ ...q, ...debouncedFilterParams }));
  }, [debouncedFilterParams]);

  const fetchItems = async queryParams => {
    let finalQueryParamsToServer = {
      ...queryParams,
    };

    if (queryParams.stockCountDate) {
      finalQueryParamsToServer = {
        ...finalQueryParamsToServer,
        startDate: format(new Date(queryParams.stockCountDate), "yyyy-MM-dd"),
        endDate: format(new Date(queryParams.stockCountDate), "yyyy-MM-dd"),
      };
    }

    let response = await fetch(
      `${backendUrl}/api/reports/stock-records?&${queryString.stringify(
        finalQueryParamsToServer
      )}`,
      {
        method: "GET",
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
        },
        credentials: "include",
      }
    );

    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const { data } = await response.json();

    data.product = [
      {
        label: "All",
        value: "",
      },
      ...data.product.map(el => ({
        label: el.Product_Name,
        value: el.Product_Name,
      })),
    ];

    data.category = [
      {
        label: "All",
        value: "",
      },
      ...data.category.map(el => ({
        label: el.Cat_Name,
        value: el.Cat_Name,
      })),
    ];

    // clean up items to match how we did the first stock count
    // G.A. added uniq some times db is connected to more than one company
    data.items = uniqBy(
      data.inventory.map(el => ({
        ...el,
        Quantity: Number(el.ClosingQty),
      })),
      "Bar_Code"
    );

    delete data.inventory;
    return data;
  };

  const { data = { count: 0, items: [] } } = useQuery(
    ["STOCK_COUNT_PRODUCTS_AT_DATE_", queryParams],
    () => fetchItems(queryParams),
    {
      keepPreviousData: true,
      enabled: !!queryParams.stockCountDate,
    }
  );

  const items = useMemo(() => {
    let arr = null;
    return arr;
  }, [data]);

  const isIronRodItem = itemDesc => {
    return itemMeasurements?.find(el => el.Size === itemDesc);
  };

  const handleFilterParamsChange = e => {
    setFilterParams({
      ...filterParams,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };

  const createStockCountAtDateProduct = useMutation(
    payload =>
      fetchActionsUtil(
        `${backendUrl}/api/stock/at-date/add`,
        "POST",
        token,
        payload
      ),
    {
      onSuccess: ({ message }) => {
        toast.success(message);
        if (refetch) refetch();
        setShowAddStockCountAtDate(false);
      },
      onError: () => {
        toast.error(`Unable to perform action`);
      },
    }
  );

  const saveItems = async () => {
    const itemsMissingBatches = selectedData.filter(
      el =>
        el.QtyCounted &&
        Number(el.QtyCounted) > 0 &&
        (!el.batches || el.batches.length === 0)
    );
    if (itemsMissingBatches.length > 0) {
      return toast.error(
        `Please select batches for: ${itemsMissingBatches
          .map(el => el.Item_Name || el.Bar_Code)
          .join(", ")}`
      );
    }

    const payload = {
      items: selectedData.filter(el => el.QtyCounted !== null),
      stockCountDate: queryParams.stockCountDate,
    };

    if (
      await ConfirmDialog({
        title: `Submit Backdated Stock Count`,
        description: `Are you sure you want to submit this record?`,
      })
    ) {
      createStockCountAtDateProduct.mutate(payload);
    }
  };

  const onChangeQtyCounted = ({
    QtyCounted,
    Bar_Code,
    Quantity,
    Item_Name,
  }) => {
    setSelectedData(oldData =>
      cloneDeep(
        oldData
          .filter(obj => obj.Bar_Code !== Bar_Code)
          .concat({
            Bar_Code,
            QtyCounted,
            QtyInStock: Quantity,
            Item_Name,
          })
      )
    );
  };

  const debouncedSelectedData = useDebounce(selectedData, 800);

  const isEqualClass = useMemo(() => {
    const output = Object.assign(
      {},
      ...debouncedSelectedData.map(item => {
        const foundSelected = debouncedSelectedData.find(
          el => el.Bar_Code === item.Bar_Code
        );
        if (isEmpty(foundSelected)) {
          return { [item.Bar_Code]: "" };
        } else if (
          Boolean(foundSelected.QtyCounted == foundSelected.QtyInStock)
        ) {
          return { [item.Bar_Code]: "correct" };
        }
        return { [item.Bar_Code]: "wrong" };
      })
    );
    return output;
  }, [debouncedSelectedData]);

  function handleFile({ eventData: e, type }) {
    /*  toast.info("Service not Available");
    return; */
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = async function(e) {
        const workbook = read(e.target.result, {
          cellDates: true,
          dateNF: "yyyy-MM-dd HH:mm:ss.SSS",
        });
        let rows = utils.sheet_to_json(
          workbook.Sheets[workbook.SheetNames[0]],
          {
            defval: "",
            dateNF: "yyyy-MM-dd HH:mm:ss.SSS",
          }
        );
        //  console.log("excel", rows);

        //--
        if (
          !(await ConfirmDialog({
            title: "Are you sure?",
            description: "You want to import",
          }))
        ) {
          return;
        }
        // TODO - validate excel
        let schema = yup.object().shape({
          items: yup.array().of(
            yup.object({
              Item_Code: yup.string().required(),
              Item_Name: yup.string().required(),
              Quantity: yup.string().default("0"),
            })
          ),
        });
        try {
          await schema.validate({ items: rows });

          // Clean Up
          rows = rows.map(el => ({
            Item_Name: el.Item_Name,
            Bar_Code: el.Item_Code,
            QtyCounted: el?.Quantity ? el?.Quantity : el?.Quantity_Counted,
          }));

          createStockCountAtDateProduct.mutate({ items: rows });
        } catch (err) {
          console.log(err);
          toast.error(err.name);
          toast.error(JSON.stringify(err.errors));
        }
      };
      reader.readAsArrayBuffer(file);
    }
    e.target.value = "";
  }

  const handleSelectBatch = ({
    Bar_Code,
    Quantity,
    isDeduction,
    quantityDifference,
  }) => {
    if (!Quantity || Number(Quantity) <= 0) {
      return toast.error("Please enter a Quantity Counted first");
    }
    setActiveBatchItem({ Bar_Code, Quantity, isDeduction, quantityDifference });
    setShowBatchSelectorModal(true);
  };

  const handleBatchSelected = ({ batches }) => {
    // console.log(batches);

    setShowBatchSelectorModal(false);
    if (!batches.length) {
      setActiveBatchItem(null);
      return;
    }
    setSelectedData(oldData =>
      cloneDeep(
        oldData.map(el =>
          el.Bar_Code === activeBatchItem.Bar_Code ? { ...el, batches } : el
        )
      )
    );
    setActiveBatchItem(null);
  };

  return (
    <Modal
      show={showAddStockCountAtDate}
      onHide={() => setShowAddStockCountAtDate(false)}
      dialogClassName="new-entity-modal"
      backdropClassName={`global-backdrop`}
      centered={true}
      animation={false}
      enforceFocus={false}
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h1>Add Stock Count for Past Date</h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="content-body">
          <header className="text-nowrap d-flex align-items-center justify-content-between gap-3 flex-wrap mb-3">
            <div className="d-flex gap-2 align-items-center flex-grow">
              <div className="global-search-area">
                <MagnifyIcon />
                <input
                  className="form-control search-input"
                  name="itemId"
                  value={filterParams?.itemId}
                  onChange={e => handleFilterParamsChange(e)}
                  placeholder="Search by Item Code..."
                  autoFocus
                  autoComplete="off"
                  type={"text"}
                />
              </div>

              <Select
                classNamePrefix="form-select"
                menuPosition="fixed"
                menuPlacement="auto"
                placeholder="All"
                name="product"
                isSearchable={true}
                key={data?.product}
                onChange={selected => {
                  setFilterParams({
                    ...filterParams,
                    product: selected.value,
                  });
                }}
                defaultValue={defaultSelectValue(
                  queryParams?.product,
                  data?.product,
                  {
                    value: "",
                    label: "Product",
                  }
                )}
                options={data?.product || []}
                isClearable
              />

              <Select
                classNamePrefix="form-select"
                menuPosition="fixed"
                className="mx-0"
                menuPlacement="auto"
                placeholder="All"
                name="category"
                isSearchable={true}
                key={data?.category}
                onChange={selected => {
                  setFilterParams({
                    ...filterParams,
                    category: selected.value,
                  });
                }}
                defaultValue={defaultSelectValue(
                  queryParams?.category,
                  data?.category,
                  {
                    value: "",
                    label: "Category",
                  }
                )}
                options={data?.category || []}
                isClearable
              />

              <Datetime
                dateFormat="DD MMM, YYYY"
                timeFormat={false}
                closeOnSelect={true}
                closeOnClickOutside={true}
                inputProps={{
                  className: `date-input form-control`,
                  placeholder: "Select Date",
                  readOnly: true,
                }}
                value={queryParams.stockCountDate}
                onChange={date => {
                  setQueryParams({
                    ...queryParams,
                    stockCountDate: date,
                  });
                }}
              />
            </div>
            <div className="d-flex gap-2 align-items-center">
              {/* EXCEL WILL NOT WORK SINCE THE USER HAS TO PICK BATCH */}
              {/* <Dropdown>
                <Dropdown.Toggle variant="" className="btn print" bsPrefix="">
                  <ExcelIcon color="#008000" />
                </Dropdown.Toggle>
                <Dropdown.Menu
                  popperConfig={{
                    strategy: "fixed",
                  }}
                  renderOnMount
                  className="text-center"
                >
                  <Dropdown.Item as="div">
                    <a
                      href={`${backendUrl}/api/items/excel/stock-count-report`}
                      target="_blank"
                      className="btn bg-transparent border-0"
                    >
                      Download <ExcelIcon color="#008000" />
                    </a>
                  </Dropdown.Item>

                  <Dropdown.Item as="div">
                    <label
                      variant=""
                      className="btn bg-transparent border-0"
                      title="Import"
                      bsPrefix=""
                    >
                      <input
                        type="file"
                        className="d-none"
                        onChange={e =>
                          handleFile({
                            eventData: e,
                            type: "",
                          })
                        }
                        accept=".xlsx"
                      />
                      Import <ExcelIcon color="#008000" />
                    </label>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown> */}

              <Button variant="primary" onClick={() => saveItems()}>
                Submit
              </Button>
            </div>
          </header>

          <div className="table-max mb-3">
            <Table borderless responsive striped className="product-table">
              <thead className="sticky border-bottom">
                <tr>
                  <th>S/N</th>
                  <th>Item Code</th>
                  <th>Item Name</th>
                  <th>
                    QTY in Stock <br />
                    <small>(Base UOM)</small>
                  </th>
                  <th>
                    QTY Counted <br />
                    <small>(Base UOM)</small>
                  </th>
                  <th>Overage / Shortage</th>
                  <th>Batch</th>
                </tr>
              </thead>

              <tbody className="position-sticky top-0">
                {data?.items &&
                  data?.items.map((el, index) => (
                    <tr
                      key={el?.Bar_Code}
                      className={isEqualClass[(el?.Bar_Code)]}
                    >
                      <td title={`${data?.startIndex}_${index}_${1}`}>
                        {data?.startIndex + index + 1}
                      </td>
                      <td>{el.Bar_Code}</td>
                      <td>
                        <p className="m-0">{el?.Item_Name}</p>
                        <small>{el.Item_Desc}</small>
                      </td>
                      <td className="p-cursor" title={el.Quantity}>
                        <ConvertQuantity
                          quantity={el.Quantity}
                          // desc={el.Item_Desc}
                        />
                      </td>
                      <td>
                        <div
                          style={{
                            width: "11rem",
                            backgroundColor: "#fff",
                          }}
                        >
                          <NumberCustomInput
                            placeholder=""
                            value={
                              selectedData.find(
                                id => id.Bar_Code === el.Bar_Code
                              )?.QtyCounted
                            }
                            onValueChange={(value, name) =>
                              onChangeQtyCounted({
                                QtyCounted: value,
                                Bar_Code: el.Bar_Code,
                                Quantity: el.Quantity,
                                Item_Name: el.Item_Name,
                              })
                            }
                          />{" "}
                        </div>
                      </td>
                      <td>
                        <ConvertQuantity
                          quantity={
                            selectedData.find(id => id.Bar_Code === el.Bar_Code)
                              ?.QtyCounted
                              ? Math.abs(
                                  Number(
                                    selectedData.find(
                                      id => id.Bar_Code === el.Bar_Code
                                    )?.QtyCounted || 0
                                  ) - Number(el.Quantity || 0)
                                )
                              : ""
                          }
                        />
                      </td>
                      <td>
                        {(() => {
                          const itemData = selectedData.find(
                            id => id.Bar_Code === el.Bar_Code
                          );
                          const batchCount = itemData?.batches?.length || 0;
                          return (
                            <Button
                              size="sm"
                              className="text-nowrap"
                              variant={
                                batchCount > 0 ? "success" : "light-blue"
                              }
                              onClick={() =>
                                handleSelectBatch({
                                  Quantity: itemData?.QtyCounted,
                                  Bar_Code: el.Bar_Code,
                                  isDeduction:
                                    Number(itemData?.QtyCounted) <
                                    Number(el.Quantity),
                                  quantityDifference: Math.abs(
                                    Number(itemData?.QtyCounted) -
                                      Number(el.Quantity)
                                  ),
                                })
                              }
                            >
                              {batchCount > 0
                                ? `Batches (${batchCount})`
                                : "Select Batch"}
                            </Button>
                          );
                        })()}
                      </td>
                    </tr>
                  ))}

                {!queryParams.stockCountDate ? (
                  <tr>
                    <td colSpan={6}>
                      <p className="m-5 text-center">Please Select Date</p>
                    </td>
                  </tr>
                ) : null}
              </tbody>
            </Table>
          </div>

          <div className="d-flex justify-content-between px-3 align-items-center pagination">
            <div className="pagination_left d-flex align-items-center gap-3">
              <p className="m-0 p-0">Show</p>
              <select
                value={queryParams.limit}
                name="limit"
                className="form-select "
                onChange={e => handleFilterParamsChange(e)}
              >
                <option value="10">10 rows</option>
                <option value="20">20 rows</option>
                <option value="30">30 rows</option>
                <option value="40">40 rows</option>
                <option value="50">50 rows</option>
                <option value="100">100 rows</option>
              </select>
            </div>

            <ReactPaginate
              {...paginationOptions}
              pageCount={Math.ceil(data.count / queryParams.limit)}
              marginPagesDisplayed={2}
              pageRangeDisplayed={0}
              onPageChange={({ selected }) => {
                scrollToTop();
                setQueryParams({
                  ...queryParams,
                  page: selected + 1,
                });
              }}
              forcePage={queryParams.page - 1}
            />
          </div>
        </div>
      </Modal.Body>
      <ModalLoader show={createStockCountAtDateProduct.isLoading} />

      {showBatchSelectorModal && activeBatchItem && (
        <BatchSelectorModal
          show={showBatchSelectorModal}
          proceed={handleBatchSelected}
          Bar_Code={activeBatchItem.Bar_Code}
          quantityToHandle={activeBatchItem.quantityDifference}
          loadBatchFromServer={true}
          stockCountDate={queryParams.stockCountDate}
          isDeduction={activeBatchItem.isDeduction}
          previouslySelectedBatches={
            selectedData.find(el => el.Bar_Code === activeBatchItem.Bar_Code)
              ?.batches || []
          }
          hasQuantity={false}
        />
      )}
    </Modal>
  );
}
